export const PRODUCT_NAME = 'InvestFlow';
export const PRODUCT_MARK = 'IF';
export const PRODUCT_TAGLINE_ZH = 'AI 驱动的投资研究工作台';
export const PRODUCT_TAGLINE_EN = 'AI-Powered Investment Research Workspace';
